import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Slider } from "@/components/ui/slider";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import { MediaPickerField } from "./MediaPickerField";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

type SectionProps = {
  maxWidth: "boxed" | "full";
  paddingY: number;
  style?: ResponsiveStyleProps;
};

export function SectionBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<SectionProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Width</Label>
          <Select
            value={props.maxWidth ?? "boxed"}
            onValueChange={(v) => setProp((p) => { p.maxWidth = v as SectionProps["maxWidth"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="boxed">Boxed</SelectItem>
              <SelectItem value="full">Full width</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Vertical padding ({props.paddingY ?? 48}px)</Label>
          <Slider
            value={[props.paddingY ?? 48]}
            max={120}
            step={4}
            onValueChange={([v]) => setProp((p) => { p.paddingY = v; })}
          />
        </div>
        <MediaPickerField
          label="Background image"
          value={{
            url: style.desktop.backgroundImage ?? null,
            mediaId: null,
            altText: null,
          }}
          onChange={(sel) =>
            updateStyle("desktop", { backgroundImage: sel.url ?? undefined })
          }
        />
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
